<template>
  <div class="container comments" id="comments_title">
    <h3
      class="comments_title title_font2 text-center text-sm-left "
      v-show="!product_review"
    >{{$t('comment.customer_review')}}</h3>
    <v-comments-write-box
      :review_count="review_count"
      :average_rating="average_rating"
      :rating_count="rating_count"
      :product_id="product_id"
      :product_review="product_review"
    ></v-comments-write-box>
    <v-comments-item-box
      :comment="comment"
      :product_id="product_id"
      :product_review="product_review"
      :review_count="review_count"
      :average_rating="average_rating"
      :rating_count="rating_count"
    ></v-comments-item-box>
  </div>
</template>
<script>
import vCommentsWriteBox from "./commentsWriteBox";
import vCommentsItemBox from "./commentsItemBox";
export default {
  props: [
    "comment",
    "review_count",
    "average_rating",
    "rating_count",
    "product_id",
    "product_review",
  ],
  data() {
    return {};
  },
  components: {
    vCommentsWriteBox,
    vCommentsItemBox
  }
};
</script>
<style scoped lang='scss'>
.comments {
  margin-bottom: 40px;
  .comments_title {
    font-size: 24px;
    padding: 20px 0;
    margin: 0;
    text-align: left;
    text-transform: capitalize;
    font-weight: 400;
    color:#2f2f2f 
  }
}
</style>